import { render, staticRenderFns } from "./71900006.vue?vue&type=template&id=38975995&scoped=true&"
import script from "./71900006.vue?vue&type=script&lang=js&"
export * from "./71900006.vue?vue&type=script&lang=js&"
import style0 from "./71900006.vue?vue&type=style&index=0&id=38975995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38975995",
  null
  
)

export default component.exports